export default {
    enter_master_password: "enter master password",
    please_enter_master_password: "please enter master password",
    store_password_permanently: "store password permanently in the browser",
    set_master_password: "set master password",
    wipe_master_password: "wipe master password",
    domain_or_url: "domain or url",
    add_domain_to_list: "add domain to list",
    password_successfully_copied: "password successfully copied to clipboard",
    copy_password_failed: "copy password to clipboard failed",
    copy_password_action_title: "copy password for domain {1} to clipboard",
    remove_domain_action_title: "remove domain {1}",
    show_password_action_title: "show password for domain {1}",
    domain_deleted: "domain {1} deleted",
    invalid_domain: "invalid domain",
    domain_added: "domain {1} added",
    domain_already_added: "domain {1} already added",
    undo: "undo",
    current_style_is: "current style is {1}",
    style_changed_to: "style changed to {1}",
    current_language_is: "current language: {1}",
    language_changed_to: "language changed to: {1}",
    password_for: "password for domain {1}:",
    close: "close",
    one_key_to_rule_them_all: "one key to rule them all...",
    select_language: 'select language:',
    select_style: 'select style:',
    read_more: 'read more...',
    show_tools: 'show tools...',
    about_singularkey: 'more information about singularkey.net',
    main_doc: 'singularkey.net is a databaseless keyring for storing passwords. ' +
              'Using one secret key (password) you can create lots of ' +
              'derived independent keys (passwords). Compared to classical keyring apps ' +
              'there is no need to remember passwords to particular services ' +
              'and passwords from this keyring are available just on the basis of knowledge ' +
              'of the main password.',
    main_algorithm_doc: 'Calculation of the derived passwords is done using the SingluarKey algorithm ' +
              'which guarantees security to the whole application. The algorithm is open and well documented ' +
              'so that the wole solution may be auditable and also other tools realizing the system of this keyring ' +
              'may be implemented.',
    tools_doc: 'Multiple tools working with the SingluarKey algorithm are also available.',
}

